import { useQuery } from '@tanstack/react-query';
import type { ApiSuccess } from '@app/shared';
import { apiClient } from '../../lib/api-client';

export interface DashboardSummary {
  myCustomerCount: number;
  totalCustomerCount: number;
  myInterviewCount7d: number;
  attachmentCount7d: number;
  activeUserCount: number | null;
  notifyDailyCount: number;
  recentInterviews: Array<{
    id: number;
    visitedAt: string | null;
    createdAt: string;
    notes: string | null;
    interviewType: { id: number; code: string; name: string } | null;
    customer: { id: number; cCode: string | null; simpleName: string; ownerId: number };
    createdBy: { id: number; displayName: string };
  }>;
  notifyDailyInterviews: Array<{
    id: number;
    createdAt: string;
    notes: string | null;
    interviewType: { id: number; code: string; name: string } | null;
    customer: { id: number; cCode: string | null; simpleName: string; phone: string | null };
    createdBy: { id: number; displayName: string };
  }>;
}

export function useDashboardSummary() {
  return useQuery({
    queryKey: ['dashboard', 'summary'],
    queryFn: async (): Promise<ApiSuccess<DashboardSummary>> => {
      const res = await apiClient.get<ApiSuccess<DashboardSummary>>('/dashboard/summary');
      return res.data;
    },
  });
}
